export const environment = {
  production: false,
  useMocks: false,
  apiUrl: '/api',
  enableLogging: true,
  bypassAuth: false,
  keycloak: {
    issuer: window.location.origin + '/iam/realms/zvk',
    redirectUri: window.location.origin,
    clientId: 'zvk-frontend',
    scope: 'openid profile email',
  },
};
